import React from 'react';
import { buildCategoryCoverUrl, categoryNameFromItem } from '../../config';
import BrandLogo from '../BrandLogo';
import { BackIcon, getAdminSessionInfo, LogoutIcon } from '../AdminCurriculumVideo/helpers';
import loadingStyles from '../shared/Loading.module.css';
import styles from '../AdminTracks.module.css';

export { getAdminSessionInfo };

export function AdminTracksLoadingState({ message, containerClassName }) {
  return (
    <div className={[loadingStyles['loading-container'], containerClassName].filter(Boolean).join(' ')}>
      <div className={loadingStyles['loading-spinner']}>
        <div className={loadingStyles['spinner-ring']} />
        <div className={loadingStyles['spinner-ring']} />
        <div className={loadingStyles['spinner-ring']} />
      </div>
      <p>{message}</p>
    </div>
  );
}

export function FeedbackBanner({ feedback, className }) {
  if (!feedback) return null;

  return (
    <div
      className={[styles['feedback'], styles[`feedback-${feedback.type}`], className].filter(Boolean).join(' ')}
      role={feedback.type === 'error' ? 'alert' : 'status'}
    >
      {feedback.message}
    </div>
  );
}

export const EditIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zm2.92 2.83H5v-.92l9.06-9.06.92.92L5.92 20.08zM20.71 7.04a1.003 1.003 0 0 0 0-1.42l-2.34-2.34a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M6 7h12v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7zm3-5h6l1 1h4v2H4V3h4l1-1zm1 8h2v10h-2V10zm4 0h2v10h-2V10z"
    />
  </svg>
);

export const ContentIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z"
    />
  </svg>
);

export const categoryId = (category) => String(category?.id ?? '').trim();

export const categoryName = (category) => categoryNameFromItem(category);

export const getCategoryCoverUrl = (category) =>
  buildCategoryCoverUrl({
    categoryId: categoryId(category),
    filename: category?.cover_image,
  });

export const sortCatalogCategories = (categories) =>
  [...(Array.isArray(categories) ? categories : [])].sort((a, b) =>
    categoryName(a).localeCompare(categoryName(b), undefined, {
      numeric: true,
      sensitivity: 'base',
    }),
  );

export function AdminCategoriesHeader({ adminInfo, onBack, onLogout }) {
  return (
    <header className={styles['admin-header']} role="banner">
      <div className={styles['header-left']}>
        <BrandLogo decorative decoding="async" to="/admin-dashboard" />
        <div className={styles['header-info']}>
          <h1 className={styles['page-title']}>Categories</h1>
          <p className={styles['page-description']}>
            Manage catalog categories and cover images
          </p>
        </div>
      </div>
      <div className={styles['header-right']}>
        <div className={styles['admin-info']}>
          <div className={styles['admin-details']}>
            <p className={styles['admin-name']}>{adminInfo.fullName}</p>
            <span className={styles['admin-details-sep']} aria-hidden="true" />
            <p className={styles['admin-email']}>{adminInfo.email}</p>
          </div>
          <button type="button" className={styles['users-button']} onClick={onBack} aria-label="Back to onboarding users">
            <BackIcon />
            Users
          </button>
          <button type="button" className={styles['logout-button']} onClick={onLogout}>
            <LogoutIcon />
            Log out
          </button>
        </div>
      </div>
    </header>
  );
}
